import React from 'react';
import { connect } from 'react-redux';

import CustomHead from '@components/CustomHead.jsx';
import LoaderBlock from '@components/loaderBlock/LoaderBlock.tsx';
import { s } from '@functions/seo.ts';
import { StoreT } from '@global/types.ts';

import getArticle from './methods/getArticle.ts';
import init from './methods/init.ts';
import setView from './methods/setView.ts';

import BlogInnerI from './types.ts';

import Menu from '../../../menu/Menu.tsx';
import renderContent from './renders/renderContent.tsx';
import renderFoot from './renders/renderFoot.tsx';

class BlogInner
    extends React.Component<BlogInnerI['props'], BlogInnerI['state']>
    implements BlogInnerI
{
    parent: BlogInnerI['parent'];

    constructor(props: BlogInnerI['props']) {
        super(props);

        this.state = {
            article: s() ? this.props.seoData?.mainArticle : undefined,
        };

        this.parent = React.createRef();
    }

    getArticle = getArticle;
    setView = setView;

    init = init;

    renderContent = renderContent;
    renderFoot = renderFoot;

    componentDidMount() {
        this.getArticle();
    }

    render() {
        const { article } = this.state;
        const imageSrc = article?.preview.fullSrc;

        return (
            <>
                <CustomHead
                    title={article?.metaTitle}
                    description={article?.metaDescription}
                    preview={imageSrc}
                />
                <div
                    ref={this.parent}
                    className={`publicBlogInner _SECTION ${article ? '_ready' : ''}`}
                >
                    <div className="publicBlogInner__inner">
                        <LoaderBlock
                            className="publicBlogInner__loader"
                            isShow={!article}
                            loaderClassName="_main"
                        />
                        {article && this.renderContent()}
                    </div>
                    {this.renderFoot()}
                </div>
                <div className="public__section _footer">
                    <Menu isFooter={true} />
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(BlogInner);
